import React from 'react';
import {
  TableRow,
  TableCell
} from '@mui/material';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';

export type MilestoneTableRowProps = {
  id: string;
  title: string;
  description: string;
  durationInDays: number;
  endDate: DateTime | null;
  installationIds: string[];
  startDate: DateTime;
  status: string;
};

export const FC = (props: MilestoneTableRowProps) => {
  const navigate = useNavigate();

  return (
    <TableRow
      content='list'
      onClick={(e) => {
        e.stopPropagation();
        navigate(`${props.id}`);
      }}
    >

      <TableCell
        variant='firstRounded'
      >
        {props.title}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.description}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.startDate.toFormat('DDDD')}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.durationInDays}
      </TableCell>
      <TableCell
        variant='body'
      >
        {props.endDate?.toFormat('DDDD') ?? ''}
      </TableCell>
      <TableCell
        variant='lastRounded'
      >
        {props.installationIds.length}
      </TableCell>
    </TableRow>

  );
};
